import { Skeleton } from '../../components/skeletons/Skeleton';
import { SkeletonCircle } from '../../components/skeletons/SkeletonCircle';

/**
 * Skeleton loading state for the logged-in profile section on login page.
 * Displays while profile is being fetched when user has auth cookies.
 */
export const LoginProfileSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Profile Picture Skeleton */}
      <div className="flex justify-center">
        <div className="relative">
          <SkeletonCircle size="w-24 h-24" className="border-4 border-brand shadow-lg" />
        </div>
      </div>

      {/* Continue Button Skeleton */}
      <Skeleton className="h-12 w-full rounded-lg" />

      {/* Logout Link Skeleton */}
      <div className="flex justify-center">
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  );
};
